(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/progress-bar/assets/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/progress-bar/assets/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.progress_bar = svs.numbergames.progress_bar || {};
svs.numbergames.progress_bar.hooks = svs.numbergames.progress_bar.hooks || {};
svs.numbergames.progress_bar.logger = new svs.core.log.Logger('numbergames:progress-bar');

 })(window);